export default __webpack_public_path__ + "static/media/upload_need_requests.9d13367d.svg";